import { Dispatch } from '@reduxjs/toolkit';

import { initialize as initializeUser } from '../features/Auth/userSlice';
import { initialize as initializeOrder } from '../features/Cart/cartSlice';
import { initialize as initializeLogin } from '../features/Auth/loginSlice';

const setInitializeData = (
  dispatch: Dispatch,
  messageData: WalletAlphaMessageData<InitializeData>
): void => {
  dispatch(
    initializeOrder({
      cartHash: messageData.data.cartHash,
      cartId: messageData.data.cartId,
      storeId: messageData.data.storeId,
    })
  );
  if (messageData.data.email) {
    dispatch(
      initializeUser({
        email: messageData.data.email,
      })
    );
  }
  if (messageData.data.channel) {
    dispatch(
      initializeLogin({
        channel: messageData.data.channel,
        type: messageData.data.loginType,
        source: messageData.data.source,
      })
    );
  }
};

export default setInitializeData;
